import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Entfernt Trailing Slashes aus dem Pfad, bevor die URL geparst wird.
 * Noetig, weil der IdentityServer auf die registrierte RedirectUri
 * '.../signin-callback/' (mit Trailing Slash) zurueckleitet, die
 * Angular-Route 'signin-callback' den Pfad '/signin-callback/' aber
 * nicht matcht - die Callback-Komponente wuerde nie laufen und der
 * Auth-Code nie gegen Tokens eingetauscht.
 */
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    return super.parse(this.removeTrailingSlash(url));
  }

  private removeTrailingSlash(url: string): string {
    const splitIndex = url.search(/[?#]/);
    const path = splitIndex === -1 ? url : url.substring(0, splitIndex);
    const rest = splitIndex === -1 ? '' : url.substring(splitIndex);
    return path.length > 1 ? path.replace(/\/+$/, '') + rest : url;
  }
}
